import { render, staticRenderFns } from "./ezCmsVela.vue?vue&type=template&id=37a78685&scoped=true"
import script from "./ezCmsVela.vue?vue&type=script&lang=js"
export * from "./ezCmsVela.vue?vue&type=script&lang=js"
import style0 from "./ezCmsVela.vue?vue&type=style&index=0&id=37a78685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a78685",
  null
  
)

export default component.exports